// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__1jsxs","defaultBar":"Section_defaultBar__3x_UD","lastSectionInCategorySection":"Section_lastSectionInCategorySection__1VHU0"};